import { Card } from '@sravni/react-design-system/lib/Card';
import { Radio } from '@sravni/react-design-system/lib/Radio';
import { Space } from '@sravni/react-design-system/lib/Space';
import { useIsMobile } from '@sravni/react-utils';
import cn from 'classnames';
import { useMemo } from 'react';

import type { TProductTypeTabConfig } from '../../types';
import { ProductTypeCardTitle } from '../ProductTypeCardTitle';

import styles from './ProductTypeCard.module.scss';

type TProductTypeCardProps = {
  tab: TProductTypeTabConfig;
  isSelected: boolean;
  onSelect: () => void;
};

export const ProductTypeCard = ({ tab, isSelected, onSelect }: TProductTypeCardProps) => {
  const isMobile = useIsMobile();

  const iconContent = useMemo(() => {
    const TabIcon = tab.icon;

    return (
      <Space
        className={styles.iconWrapper}
        align="center"
        justify="center"
      >
        <TabIcon className={styles.icon} />
      </Space>
    );
  }, [tab.icon]);

  return (
    <Card
      variant="outlined"
      size={16}
      className={cn(styles.card, { [styles.selected]: isSelected })}
      onClick={onSelect}
    >
      {isMobile ? (
        <Space
          className={styles.mobileContent}
          align="center"
          justify="space-between"
          size={12}
        >
          <Space
            align="center"
            size={12}
            className={styles.mobileMain}
          >
            {iconContent}
            <ProductTypeCardTitle {...tab} />
          </Space>
          <Radio checked={isSelected} />
        </Space>
      ) : (
        <Space
          className={styles.desktopContent}
          direction="vertical"
          size={12}
        >
          <Space
            className={styles.desktopHeader}
            justify="space-between"
          >
            {iconContent}
            <Radio checked={isSelected} />
          </Space>
          <ProductTypeCardTitle {...tab} />
        </Space>
      )}
    </Card>
  );
};
